<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a><a id="page_2"></a>
<h1 class="title"><a id="page_3"></a>At the Crossroad</h1>
<p class="subtit">A Black Horse Campground Mystery</p>
<p class="author">Amy M. Bennett</p>
<div class="img_containert1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?1839810b